import React, { useState, FC } from 'react'
import { BottomNavigation, BottomNavigationAction, Box, Fab, Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField } from '@mui/material'
import { Link, useNavigate } from 'react-router-dom'
import ExploreIcon from '@mui/icons-material/Explore'
import Diversity3Icon from '@mui/icons-material/Diversity3'
import GroupAddIcon from '@mui/icons-material/GroupAdd'
import CreateIcon from '@mui/icons-material/Create'
import { useTranslation } from 'react-i18next'


const NetworksBottomNav: FC = () => {
  const { t } = useTranslation()
  const [value, setValue] = useState(0)

  return (
    <>
      <Box sx={{ width: '100%', position: 'fixed', bottom: 0, backgroundColor: 'white', boxShadow: '0 -1px 5px rgba(0,0,0,0.1)', zIndex: 10 }}>
        <BottomNavigation
          value={value}
          onChange={(event, newValue) => {
            setValue(newValue)
          }}
          showLabels
        >
          <BottomNavigationAction
            component={Link}
            to="/networks/joins"
            label={t('page.networks.navItem.mobileJoins')}
            icon={<Diversity3Icon />}
          />
          <BottomNavigationAction
            component={Link}
            to="/networks/discover"
            label={t('page.networks.navItem.discover')}
            icon={<ExploreIcon />}
          />
          <BottomNavigationAction
            component={Link}
            to="/networks/invitations"
            label={t('page.networks.navItem.invitations')}
            icon={<GroupAddIcon />}
          />
          <BottomNavigationAction
            component={Link}
            to="/networks/create"
            label={t('page.networks.navItem.create')}
            icon={<CreateIcon />}
          />
        </BottomNavigation>
      </Box>
    </>
  )
}

export default NetworksBottomNav
